import {Slice} from '@reduxjs/toolkit';
import {createContext} from 'react';

export interface ISliceContext {
    slice: Slice;
}

export const SliceContext = createContext<ISliceContext>({} as ISliceContext);
